export const SettingsIcon = (props: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
        stroke="none"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        {...props}
      />
      <path
        d="M1.3335 8.58679V7.41345C1.3335 6.72012 1.90016 6.14679 2.60016 6.14679C3.80683 6.14679 4.30016 5.29345 3.6935 4.24679C3.34683 3.64679 3.5535 2.86679 4.16016 2.52012L5.3135 1.86012C5.84016 1.54679 6.52016 1.73345 6.8335 2.26012L6.90683 2.38679C7.50683 3.43345 8.4935 3.43345 9.10016 2.38679L9.1735 2.26012C9.48683 1.73345 10.1668 1.54679 10.6935 1.86012L11.8468 2.52012C12.4535 2.86679 12.6602 3.64679 12.3135 4.24679C11.7068 5.29345 12.2002 6.14679 13.4068 6.14679C14.1002 6.14679 14.6735 6.71345 14.6735 7.41345V8.58679C14.6735 9.28012 14.1068 9.85345 13.4068 9.85345C12.2002 9.85345 11.7068 10.7068 12.3135 11.7535C12.6602 12.3601 12.4535 13.1335 11.8468 13.4801L10.6935 14.1401C10.1668 14.4535 9.48683 14.2668 9.1735 13.7401L9.10016 13.6135C8.50016 12.5668 7.5135 12.5668 6.90683 13.6135L6.8335 13.7401C6.52016 14.2668 5.84016 14.4535 5.3135 14.1401L4.16016 13.4801C3.5535 13.1335 3.34683 12.3535 3.6935 11.7535C4.30016 10.7068 3.80683 9.85345 2.60016 9.85345C1.90016 9.85345 1.3335 9.28012 1.3335 8.58679Z"
        stroke="none"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
        {...props}
      />
    </svg>
  )
}
